import IntElement from './int-element';

export {
  IntElement
}



// WEBPACK FOOTER //
// src/common/form-elements/int-element-folder/index.js